import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { BankAccountInterface } from "../../Entity/Entities/BankAccount/BankAccountInterface";
import BankAccountFactory from "../../Entity/Factories/BankAccountFactory";
import Translator from "../../Translation/Translator";

export default function* bankAccountCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_BANK_ACCOUNT_CREATE_REQUEST
    });

    const res = yield call(Http.post, `bankAccount`, {
      ...action.payload?.bankAccount
    });

    const bankAccount: BankAccountInterface = BankAccountFactory.create(res.data.data);
    yield put({
      type: Constants.GLOBAL_BANK_ACCOUNT_CREATE_SUCCESS,
      payload: {
        bankAccount: bankAccount
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-bank-account-created-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, bankAccount);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_BANK_ACCOUNT_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchBankAccountCreate() {
  yield takeEvery(Constants.GLOBAL_BANK_ACCOUNT_CREATE_START, bankAccountCreate);
}
